// ASETQU LAND is finished but held back from release. Its pages, hooks and
// services all stay in the tree; the flag decides whether the routes are
// mounted and whether the links appear.
//
// Vite inlines import.meta.env.VITE_* at build time, so this must stay a
// direct property read rather than a lookup through a variable.
export const asetquLandEnabled = import.meta.env.VITE_FEATURE_ASETQU_LAND === 'true';
